'use strict';

var _ = require('lodash');
function SystemConfigurationToolbarBookmarksService(SystemConstants, featureToggleService, userSecureService) {
  var testingComponent = _.find(userSecureService.getUserPrivileges(), {
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER_ADVANCED_HEP
  });
  var sysParamComponent = testingComponent ? SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER_ADVANCED_HEP : SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER;
  var BOOKMARKS = [{
    label: 'System Param',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER,
    component: sysParamComponent
  }, {
    label: 'Mkt Class Fare',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_CLASS_FARE,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_CLASS_FARE,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    ifFeatureDisabled: ['FIM']
  }, {
    label: 'Budget/Target',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.BUDGET_TARGET,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.BUDGET_TARGET,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Entity',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.ENTITY,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.ENTITY,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'User Def Ref Data',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.USER_DEFINED_REF_DATA,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.USER_DEFINED_REF_DATA,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Disc Routes',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.DISCONTINUED_ROUTES,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.DISCONTINUED_ROUTES,
    ifFeatureEnabled: ['DISCONTINUED_ROUTES']
  }, {
    label: 'Mkt Asgmt',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_ASSIGN,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_ASSIGN,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Flight Asgmt',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FLIGHT_ASSIGNMENT,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FLIGHT_ASSIGNMENT,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Leg Asgmt',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.LEG_ASSIGNMENT,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.LEG_ASSIGNMENT,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Host Mkt Share',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.HOST_SHARE,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.HOST_SHARE,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Events',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.EVENTS,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.EVENTS,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Flight Category',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FLIGHT_TAG,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FLIGHT_TAG,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Web Fare',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.WEB_FARE,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.WEB_FARE,
    ifFeatureDisabled: ['DYNAMIC_AVAILABILITY', 'FARES_OPTIMIZER'],
    ifFeatureEnabled: ['COMPFARE_AVAILABILITY', 'USE_WEB_FARE']
  }, {
    label: 'Mkt Class Fare Influences',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_CLASS_FARE_INFLUENCES,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_CLASS_FARE_INFLUENCES,
    ifFeatureEnabled: ['DYNAMIC_AVAILABILITY']
  }, {
    label: 'Linked Fares',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.LINKED_FBC,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.LINKED_FBC,
    ifFeatureEnabled: ['FARES_OPTIMIZER']
  }, {
    label: 'Fare Creator',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FARE_BUILDER,
    component: SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.FARE_BUILDER,
    ifFeatureEnabled: ['FARES_OPTIMIZER']
  }];
  function getBookmarks() {
    return _.filter(BOOKMARKS, featureToggleService.isEnabledBasedOnConfig);
  }
  return {
    getBookmarks: getBookmarks
  };
}
SystemConfigurationToolbarBookmarksService.$inject = ['SystemConstants', 'FeatureToggleService', 'UserSecureService'];
module.exports = SystemConfigurationToolbarBookmarksService;